import { useState } from "react";

import useEffectOnce from "./useEffectOnce";

export default function useIsSsr() {
    const [isSsr, setIsSsr] = useState(true);

    useEffectOnce(() => {
        setIsSsr(false);
    });

    return isSsr;
}
